/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue"
import App from "./App.vue"
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import router from "./router"
import Argon from "./plugins/argon-kit"
import CONSTANTS from './constants'
import i18n from './i18n'
import VueMapbox from "vue-mapbox";
import Mapbox from "mapbox-gl";
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(VueAxios, axios)
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    currentLanguage: 0
  },
  mutations: {
  	nextLang: state => {
      state.currentLanguage=(state.currentLanguage+1)%CONSTANTS.LANGUAGES.length
      i18n.locale=CONSTANTS.LANGUAGES[state.currentLanguage]
    },
  }
})
Vue.use(VueMapbox, { mapboxgl: Mapbox });
Vue.use(VueGtag, {
  config: { id: 'G-RGNLKXJXYD' },
  pageTrackerScreenviewEnabled: true
}, router);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
